module.exports = __webpack_public_path__ + "img/SA6400.db1e4fab.png";